import PropTypes from '../../../utils/propTypes';
import DoubleBar from '../DoubleBar';
import { MasterBlock } from '../MasterBlock';

export const ConcreteTotalWidget = ({ table, title, values, children }) => {
  return (
    <MasterBlock title={title} color="#B0B0B0">
      <div
        className="card-header"
        style={{
          fontSize: '16px',
          width: '100%',
        }}
      >
        Total
      </div>
      <DoubleBar table={table} values={values} />
      {children}
    </MasterBlock>
  );
};

ConcreteTotalWidget.propTypes = {
  table: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  values: PropTypes.shape({
    poured: PropTypes.number,
    projected: PropTypes.number,
    resistant: PropTypes.number,
  }).isRequired,
};
